export const CARD_THRESHOLD = 9;
